<template>
  <v-container fluid style="padding: 0;">
    <v-layout justify-center align-top row wrap v-if="init">
      <div>
        <v-flex>
          <v-layout align-center>
            <v-flex xs12 id="title"><h3>Для начала работы сделайте несколько шагов по настройке приложения</h3></v-flex>
          </v-layout>
        </v-flex>

        <AssistantStep :is-setup="true" step="reg"/>
        <AssistantStep :is-setup="initialSetup.sms" step="sms"/>
        <AssistantStep :is-setup="initialSetup.profile" step="profile"/>
        <AssistantStep :is-setup="initialSetup.page" step="page"/>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import AssistantStep from '../components/AssistantStep'

export default {
  components: {
    AssistantStep
  },
  data: () => ({
    init: false,
    initialSetup: {
      sms: false,
      profile: false,
      page: false
    }
  }),
  created () {
    this.$store.commit('showNavigation')
    this.getInfo()
  },
  methods: {
    getInfo: function () {
      axios.get('/api/assistant')
        .then(response => {
          this.initialSetup = response.data
          this.init = true
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    }
  }
}
</script>

<style scoped>
#percent {
  font-size: 30px;
  color: #4caf50;
  text-align: end;
  padding-right: 15px;
}
#title {
  padding: 15px;
}
</style>
